import React from 'react';
import api from '../../helpers/api';
import styles from './AssignmentRequests.module.scss';
import Tooltip from '../miscellaneous/Tooltip/Tooltip';
import { FiInfo } from 'react-icons/fi';
import DataTable from '../miscellaneous/DataTable/DataTable';
import { $t } from '../../helpers/translator';
import _ from "lodash";
import {connect} from "react-redux";
import AssignClinicToChain from "../AssignClinicToChain/AssignClinicToChain";
import HasPermission from 'helpers/permissions/HasPermission';

class AssignmentRequests extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userType: 2,
            translations: {},
            requests: null,

            showAssignClinicModal: false,
            assignClinic: {
                clinicNumber: '',
                error: '',
                serverError: ''
            },
            assignmentError: ''
        };
    }

    async componentDidMount() {
        let userType = this.props.userType ? this.props.userType : 2;   //fallback to type clinic if not provided
        let translations = {
            2: {
                chainId: $t('global.account.chainId'),
                chainName: $t('global.account.chainName'),
                chainNumber: $t('global.account.chainNumber'),
                chainRequestApprove: $t('global.account.chainRequestApprove'),
                chainRequestDecline: $t('global.account.chainRequestDecline'),
                approve: $t('global.account.approve'),
                decline: $t('global.account.decline'),
                assignmentRequestsExplain: $t('global.account.assignmentRequestsExplain'),
            },
            3: {
                chainId: $t('global.account.clinicId'),
                chainName: $t('global.account.clinicName'),
                chainNumber: $t('global.account.clinicNumber'),
                chainRequestApprove: $t('global.account.clinicRequestReSend'),
                chainRequestDecline: $t('global.account.clinicRequestDelete'),
                approve: $t('global.account.reSend'),
                decline: $t('global.account.delete'),
                assignmentRequestsExplain: $t('global.account.assignmentRequestsExplainForChain'),
            }
        }

        this.setState({translations: translations[userType], userType: userType}, async () => {
            await this.getData();
        })
    }

    async getData() {
        let translations = this.state.translations;

        try {
            // let res = await api.fetchSubClinicRequests();
            let res = await api.get('/clinic/requests');
            // console.log(res)
            if (res && res.data && res.data.data) {

                _.forEach(res.data.data, (v, k) => {
                    switch (v.status) {
                        case 0:
                            v.status = <div className={styles.yellow}>{$t('global.account.pending')}</div>
                            break;
                        case -1:
                            v.status = <div className={styles.red}>{$t('global.account.declined')}</div>
                            break;
                        case 1:
                            v.status = <div className={styles.green}>{$t('global.account.approved')}</div>
                            break;
                        default:
                            break;
                    }

                    v.approveRequest =
                    <HasPermission permission={["clinic.create", "clinic.edit"]} match="any">
                        <Tooltip content={translations.chainRequestApprove}>
                            <div className={`${styles['green-link']}`}
                                 onClick={() => this.approveRequest(v.id)}>{translations.approve}</div>
                        </Tooltip>
                    </HasPermission>
                        ;
                    v.declineRequest =
                        <HasPermission permission="clinic.delete">
                            <Tooltip content={translations.chainRequestDecline}>
                                <div className={`${styles['red-link']}`}
                                    onClick={() => this.declineRequest(v.id)}>{translations.decline}</div>
                            </Tooltip>
                        </HasPermission>;
                })

                this.setState({requests: res.data.data})
            }

        } catch (e) {
            console.error('error getting account data,', e);
        }
    }

    tableActionHandler(data) {
        // console.log(data)
    }

    async approveRequest(id) {
        try {
            let res = await api.post('/clinic/request/approve', {clinic_id: id})
            window.location.reload();
            // let res = await api.approveClinicRequest(id);
            await this.getData()
        } catch (e) {
            console.error('err approve')
        }
    }

    async declineRequest(id) {
        //if user is clinic - decline request
        //if user is chain - delete request
        let url = this.state.userType === 2 ? '/clinic/request/decline' : '/clinic/request/delete';


        try {
            let res = await api.post(url, {clinic_id: id})

            // let res = await api.declineClinicRequest(id);
            await this.getData();
        } catch (e) {
            console.error('err approve')
        }
    }


    render() {
        let userType = this.state.userType;
        let translations = this.state.translations;

        // userType = 2;

        let tableHeaders = [
            {
                name: translations.chainId,
                id: 'id',
            },
            {
                name: translations.chainNumber,
                id: 'clinic_number',
            },
            {
                name: translations.chainName,
                id: 'name',
            },
            {
                name: $t('global.account.country'),
                id: 'country_name',
            },
            {
                name: $t('global.account.status'),
                id: 'status',
            },
            ...(userType === 2 ? [{
                name: '',
                id: 'approveRequest',
            }] : []),
            {
                name: '',
                id: 'declineRequest',
            },
        ];

        // console.log('tableheaders', tableHeaders)

        return (
            <div>
                <div className={`alma-box ${styles['container']}`}>
                    <div className={'alma-box-header'}>
                        <span><h3>{$t('global.account.assignmentRequests')}</h3></span>
                        {this.state.userType === 3 && <AssignClinicToChain onchange={() => this.getData()}/>}
                        {/*<Tooltip*/}
                        {/*    content={$t('global.account.assignmentRequestsExplainForChain')}>*/}
                        {/*    <FiInfo className={`${styles['info-icon']}`}/>*/}
                        {/*</Tooltip>*/}
                    </div>

                    <div className={`${styles['table-container']}`}>
                        {this.state.requests ?
                            <DataTable data={this.state.requests}
                                       headers={tableHeaders}
                                // pagination={this.state.pagination}
                                // sorted={this.state.dataTableParameters.sorted}
                                // childrenArrayName={'treatments'}
                                       onAction={this.tableActionHandler.bind(this)}/>
                            :
                            null
                        }
                    </div>
                </div>

            </div>
        );
    }

}

// export default ClinicAssignmentRequests;

const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(AssignmentRequests);
